<template>
	<div id="patientExamsPage" class="layout-row">
		<div class="container mt-sm-5">
			<div class="card m-sm-2 shadow-sm border-0">
				<div class="d-flex flex-column">
					<div class="d-sm-flex flex-row align-items-center d-none border-bottom">
						<div class="p-2 w-50 text-muted">{{ $t('Exam') }}</div>
						<div class="p-2 flex-fill text-muted">{{ $t('RealizedAt') }}</div>
						<div class="p-2 flex-fill text-right text-muted">{{ $t('Actions') }}</div>
					</div>
					<paginate
						name="exams"
						tag="div"
						class="flex-fill exams-list"
						:list="exams"
						:per="10"
					>
						<div class="d-flex flex-sm-row flex-column align-items-sm-center exam-item" v-for="item in paginated('exams')" :key="item.id">
							<div class="p-2 w-50 exam-title">{{item.title}}</div>
							<div class="p-2 flex-fill">
								<div class="text-muted d-block d-sm-none">{{ $t('RealizedAt') }}</div> 
								{{ moment(item.finished_at).isValid() ? moment(item.finished_at).format('llll') : '-' }}
							</div>
							<div class="p-2 flex-fill text-right">
								<router-link class="btn btn-secondary btn-sm" 
								:to="{name: 'patientExamView', params: {examId: item.id} }">{{ $t('Open') }}</router-link>
							</div>
						</div>
					</paginate>
					<div class="p-2" v-if="busy">
						<app-loader />
					</div>
					<div class="p-2 border-top">
						<paginate-links for="exams"
							class="float-right"
									:classes="{
										'ul': ['pagination', 'float-right', 'mb-0'],
										'li': 'page-item',
										'li > a': ['btn', 'btn-sm', 'btn-light', 'ml-2']
									}"
								></paginate-links>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {Patient} from '@/services'

export default {
	name: "patientExamsPage",
	data() {
		return {
			exams: [],
			paginate: ['exams'],
			busy: true
		};
	},

	beforeCreate() {
		Patient.getExams()
		.then(response => {
			this.busy = false;
			this.exams = response.data;
		})
	}
};

</script>

<style lang="scss">
@import "../../assets/_vars";

.container {
	@media screen and (max-width: $mobile) {
		padding:0 !important;
		height:100%;
	}
	.exams-list {
		overflow: auto;

		.exam-item {
			border-bottom:1px solid rgba(0,0,0,0.1);

			.exam-title {
				@media screen and (max-width: $mobile) {
					width:100% !important;
					font-weight: bold;
				}
			}
		}
	}
	.pagination {
		margin:0;

		.active {
			li {
				a {
					font-weight: 700;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/patient/patientExamsPage.vue